import FinderContainer from './finder_container';

const Finder = FinderContainer;

export default Finder;
